module.exports = __webpack_public_path__ + "static/media/figure-drawing-walnut-ink_female-FIVE.6a945c6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/figure-drawing-walnut-ink_female-FIVE.jpg
// module id = 247
// module chunks = 1